export const GET_ENGINE_VIEW_LOGS = 'GET_ENGINE_VIEW_LOGS';
export const GET_ENGINE_VIEW_LOGS_SUCCESS = 'GET_ENGINE_VIEW_LOGS_SUCCESS';
export const GET_ENGINE_VIEW_LOGS_FAILURE = 'GET_ENGINE_VIEW_LOGS_FAILURE';
export const ENGINE_LOGS_RESET = 'ENGINE_LOGS_RESET';
